'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _normalizers = require('@colony/purser-core/normalizers');

var _bn = require('bn.js');

var _bn2 = _interopRequireDefault(_bn);

var _ethereumjsTx = require('ethereumjs-tx');

var _ethereumjsTx2 = _interopRequireDefault(_ethereumjsTx);

var _ethers = require('ethers');

var _web3Utils = require('web3-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EthersWrappedWallet = function () {
  function EthersWrappedWallet(wallet, provider) {
    (0, _classCallCheck3.default)(this, EthersWrappedWallet);

    this.wallet = wallet;
    this.provider = provider;
  }

  (0, _createClass3.default)(EthersWrappedWallet, [{
    key: 'getAddress',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.wallet.address);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAddress() {
        return _ref.apply(this, arguments);
      }

      return getAddress;
    }()
  }, {
    key: 'signMessage',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(message) {
        var payload;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                payload = typeof message === 'string' && !(0, _web3Utils.isHex)(message) ? { message: message } : { messageData: message };
                return _context2.abrupt('return', this.wallet.signMessage(payload));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signMessage(_x) {
        return _ref2.apply(this, arguments);
      }

      return signMessage;
    }()

    /**
     * Given a partial transaction request, sets the remaining required fields,
     * signs the transaction with the Purser wallet and sends it using the
     * provider.
     */

  }, {
    key: 'sendTransaction',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(tx) {
        var chainId, data, gasLimit, gasPrice, nonce, to, value, signOptions, signedTx, txHash, parsedSignedTx, transaction;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                chainId = tx.chainId, data = tx.data, gasLimit = tx.gasLimit, gasPrice = tx.gasPrice, nonce = tx.nonce, to = tx.to, value = tx.value;
                _context3.t0 = chainId || this.provider.chainId;
                _context3.t1 = data;

                if (!gasLimit) {
                  _context3.next = 7;
                  break;
                }

                _context3.t2 = new _bn2.default(gasLimit);
                _context3.next = 12;
                break;

              case 7:
                _context3.next = 9;
                return this.estimateGas(tx);

              case 9:
                _context3.t3 = new _bn2.default('11');
                _context3.t4 = new _bn2.default('10');
                _context3.t2 = _context3.sent.mul(_context3.t3).div(_context3.t4);

              case 12:
                _context3.t5 = _context3.t2;

                if (!gasPrice) {
                  _context3.next = 17;
                  break;
                }

                _context3.t6 = new _bn2.default(gasPrice);
                _context3.next = 20;
                break;

              case 17:
                _context3.next = 19;
                return this.getGasPrice();

              case 19:
                _context3.t6 = _context3.sent;

              case 20:
                _context3.t7 = _context3.t6;
                _context3.t8 = nonce;

                if (_context3.t8) {
                  _context3.next = 26;
                  break;
                }

                _context3.next = 25;
                return this.getTransactionCount();

              case 25:
                _context3.t8 = _context3.sent;

              case 26:
                _context3.t9 = _context3.t8;
                _context3.t10 = to;
                _context3.t11 = value;
                signOptions = {
                  chainId: _context3.t0,
                  data: _context3.t1,
                  gasLimit: _context3.t5,
                  gasPrice: _context3.t7,
                  nonce: _context3.t9,
                  to: _context3.t10,
                  value: _context3.t11
                };
                _context3.next = 32;
                return this.sign(signOptions);

              case 32:
                signedTx = _context3.sent;
                txHash = void 0;

                if (!(this.wallet.subtype === 'metamask')) {
                  _context3.next = 39;
                  break;
                }

                // if metamask, tx has already been sent
                // TODO: add `online` main wallet type or similar to Purser
                parsedSignedTx = new _ethereumjsTx2.default(signedTx);

                txHash = (0, _normalizers.hexSequenceNormalizer)(parsedSignedTx.hash().toString('hex'));
                _context3.next = 42;
                break;

              case 39:
                _context3.next = 41;
                return this.provider.sendTransaction(signedTx);

              case 41:
                txHash = _context3.sent;

              case 42:
                _context3.next = 44;
                return this.provider.getTransaction(txHash);

              case 44:
                transaction = _context3.sent;
                return _context3.abrupt('return', transaction || this.provider.waitForTransaction(txHash));

              case 46:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sendTransaction(_x2) {
        return _ref3.apply(this, arguments);
      }

      return sendTransaction;
    }()

    /**
     * Estimates the gas cost of a transaction using the provider and converts to
     * our BN format.
     */

  }, {
    key: 'estimateGas',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(tx) {
        var from, transformedTx, estimate;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getAddress();

              case 2:
                from = _context4.sent;
                transformedTx = (0, _extends3.default)({}, tx, { from: from });
                _context4.next = 6;
                return this.provider.estimateGas(transformedTx);

              case 6:
                estimate = _context4.sent;
                return _context4.abrupt('return', new _bn2.default(estimate.toString()));

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function estimateGas(_x3) {
        return _ref4.apply(this, arguments);
      }

      return estimateGas;
    }()

    /**
     * Gets the gas price from the provider and converts to our BN format.
     */

  }, {
    key: 'getGasPrice',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
        var price;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.provider.getGasPrice();

              case 2:
                price = _context5.sent;
                return _context5.abrupt('return', new _bn2.default(price.toString()));

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getGasPrice() {
        return _ref5.apply(this, arguments);
      }

      return getGasPrice;
    }()
  }, {
    key: 'getBalance',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        var address;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getAddress();

              case 2:
                address = _context6.sent;
                return _context6.abrupt('return', this.provider.getBalance(address));

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getBalance() {
        return _ref6.apply(this, arguments);
      }

      return getBalance;
    }()
  }, {
    key: 'getTransactionCount',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
        var address;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getAddress();

              case 2:
                address = _context7.sent;
                return _context7.abrupt('return', this.provider.getTransactionCount(address));

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getTransactionCount() {
        return _ref7.apply(this, arguments);
      }

      return getTransactionCount;
    }()

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'parseTransaction',
    value: function parseTransaction(tx) {
      return _ethers.utils.parseTransaction(tx);
    }
  }, {
    key: 'send',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(to, value) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', this.sendTransaction((0, _extends3.default)({
                  to: to,
                  value: value
                }, options)));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function send(_x5, _x6) {
        return _ref8.apply(this, arguments);
      }

      return send;
    }()

    /**
     * Sign a given complete transaction request in Ethers format using Purser.
     */

  }, {
    key: 'sign',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(_ref9) {
        var data = _ref9.data,
            tx = (0, _objectWithoutProperties3.default)(_ref9, ['data']);
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', this.wallet.sign((0, _extends3.default)({}, tx, { inputData: data })));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function sign(_x7) {
        return _ref10.apply(this, arguments);
      }

      return sign;
    }()

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'verifyMessage',
    value: function verifyMessage(message, signature) {
      return _ethers.utils.verifyMessage(message, signature);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'encrypt',
    value: function encrypt() {
      throw new Error('Wallet method "encrypt" not available');
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'address',
    get: function get() {
      return this.wallet.address;
    }
  }, {
    key: 'privateKey',
    get: function get() {
      throw new Error('Wallet property "privateKey" not available');
    }

    // eslint-disable-next-line class-methods-use-this
    ,
    set: function set(privateKey) {
      throw new Error('Wallet property "privateKey" not available');
    }
  }]);
  return EthersWrappedWallet;
}();

exports.default = EthersWrappedWallet;
//# sourceMappingURL=index.js.map